import gql from "graphql-tag";

export const SiteGroupObjectQuery = gql `
query{
    getSiteGroupObject {
      response
    }
}
`;


export const getSiteGroups = gql `
query($input: SiteGroupFilter!){
    sitegroups(input: $input) {

      sitegroups{
      
        _id
        sitegroupname
        customer 
        branch
        branchLocked
        metadata
        createdDate
        updatedDate

      }
        
      totalCount
      currentPage
      totalPages


    }
}
`;

export const getSiteGroup = gql `
query($id: String!){
  siteGroup(_id: $id) {
    response 
    message
  }
}
`;

export const getSiteGroupPayTableQuery = gql `
query($sitegroupId: String!){
  getSiteGroupPayTable(sitegroupId: $sitegroupId) {
    response
    message
  }
}
`;
// one customer's site groups - the site form lists these once a customer is picked
export const SiteGroupsForCustomerQuery = gql `
query($customerId: String!){
  siteGroupsForCustomer(customerId: $customerId) {
    response
  }
}
`;
